import React, { useState, useEffect } from "react";
import { TelephoneFill } from "react-bootstrap-icons";
import "../../../../assets/custom/css/custom.css";
import SampleAudio from "./sample.mp3";
import { Headset } from "react-bootstrap-icons";

function ChatWidget({ forwardedRef }) {
  const [seconds, setSeconds] = useState(0);
  const [isChatOpen, setIsChatOpen] = useState(true);
  const [isMinimized, setIsMinimized] = useState(false);
  const [shake, setShake] = useState(false);
  const [dialNumber, setDialNumber] = useState("");
  const [activePause, setActivePause] = useState(false);
  const [activeMic, setActiveMic] = useState(false);
  const [showPhone, setShowPhone] = useState("DISCONNECTED");
  const [value, setValue] = useState(false);

    useEffect(() => {
      const interval = setInterval(() => {
        const savedStatus = sessionStorage.getItem("webrtcPhoneStatus");
        setValue(savedStatus);
        if (savedStatus && savedStatus !== showPhone) {
          if (savedStatus === "CONNECTED") {
            setShowPhone(true);
          } else {
            setShowPhone(false);
          }
        }
      }, 1000); // check every 1 second
  
      return () => clearInterval(interval); 
    }, [showPhone]);

  // useEffect(() => {
  //   if (isChatOpen) {
  //     const timeout = setTimeout(() => {
  //       try {
  //         require("./demo-1");
  //       } catch (err) {
  //         console.error("Error loading demo files:", err);
  //       }
  //     }, 1000);

  //     return () => clearTimeout(timeout);
  //   }
  // }, [isChatOpen]);

useEffect(() => {
  if (value === "CONNECTED") {
    const startTimeStr = sessionStorage.getItem("webrtcPhoneStartTime");
    const startTime = startTimeStr ? new Date(startTimeStr).getTime() : Date.now();

    const interval = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      setSeconds(elapsed);
    }, 1000);

    return () => clearInterval(interval);
  }
}, [value]);

useEffect(() => {
  if (isChatOpen && value === "CONNECTED") {
    const timeout = setTimeout(() => {
        try {
          require("./demo-1");
        } catch (err) {
          console.error("Error loading demo files:", err);
        }
      }, 1000);

      return () => clearTimeout(timeout);
  }
}, [value, isChatOpen])

    useEffect(() => {
    if (forwardedRef) {
      forwardedRef.current = {
        minimize: () => setIsMinimized(true),
        maximize: () => setIsMinimized(false),
        toggle: () => setIsMinimized(prev => !prev)
      };
    }
  }, [forwardedRef]);

  useEffect(() => {
    const interval = setInterval(() => {
      setShake(true);
      setTimeout(() => setShake(false), 500);
    }, 2700);
    return () => clearInterval(interval);
  }, []);

  // const handleToggleChat = () => {
  //   setIsChatOpen(true);
  //   setIsMinimized(false);
  // };

  const handleCloseChat = () => {
    setIsChatOpen(false);
    setIsMinimized(false);
  };

  const handleMinimizeChat = () => {
    setIsMinimized(true);
  };

  const handleMaximizeChat = () => {
    setIsMinimized(false);
  };

  const handleDigitClick = (digit) => {
    setDialNumber((prev) => prev + digit);
  };

  const handleBackspace = () => {
    setDialNumber((prev) => prev.slice(0, -1));
  };

  const togglePause = () => setActivePause((prev) => !prev);
  const toggleMic = () => setActiveMic((prev) => !prev);

  const formatTime = (time) => {
    if (value === "DISCONNECTED") return;
    const hrs = String(Math.floor(time / 3600)).padStart(2, "0");
    const mins = String(Math.floor((time % 3600) / 60)).padStart(2, "0");
    const secs = String(time % 60).padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };
  return (
    <>
      {/* <div
        className="chat-launcher bg-white rounded-circle shadow"
        onClick={handleToggleChat}
      >
        <TelephoneFill
          size={28}
          color="#0d6efd"
          className={shake ? "shake-icon" : ""}
        />
      </div> */}

      <div
      style={{
        padding:"0",
        height:"auto"
      }}
        className={`chatbox-wrapper ${isChatOpen ? "active" : ""} ${
          isMinimized ? "minimized" : ""
        }`}
      >
        {/* <span className="chat-title" style={{ textAlign: "center" }}>Dialer</span> */}

        <div className="chat-iframe" style={{ 
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden"
        }}>
          <div className="container" style={{ 
            width: "420px",
            // minHeight: "550px",
            borderRadius: "16px",
            // padding: "20px",
            margin: "0 auto"
          }}>
         
            {/* <div className="connection">
              <button id="connect" className="keypadConnect">Connect</button>
              <button id="disconnect" className="disconnect">Disconnect</button>
            </div> */}
            {value === "CONNECTED" && 
            <div
              className="waiting-status"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                padding: "10px 16px",
                marginBottom: "10px",
                background: "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)",
                borderRadius: "10px",
                border: "1px solid #93c5fd",
                boxShadow: "0 2px 4px rgba(59, 130, 246, 0.1)",
              }}
            >
              <Headset size={20} color="#2563eb" />
              <span style={{ fontSize: "14px", color: "#1e40af", fontWeight: "500" }}>Call Duration</span>
              <span
                style={{
                  fontWeight: "700",
                  fontSize: "16px",
                  color: "#1e40af",
                  fontFamily: "monospace",
                  letterSpacing: "1px",
                }}
              >
                {formatTime(seconds)}
              </span>
            </div>}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                marginBottom: "15px",
                marginTop: "15px",
                padding: "0 10px",
              }}
            >
              <div style={{ 
                display: "flex", 
                alignItems: "stretch",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                borderRadius: "12px",
                overflow: "hidden",
                border: "2px solid #e0e7ff",
                width: "90%",
                margin: "0 auto"
              }}>
                <div
                  style={{
                    background: "linear-gradient(135deg, #081d5d 0%, #1e3a8a 100%)",
                    color: "white",
                    padding: "6px 12px",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    flexShrink: 0
                  }}
                >
                  +91
                </div>

                <input
                  type="text"
                  id="numberToCall"
                  value={dialNumber}
                  onChange={() => {}}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace") {
                      e.preventDefault();
                      setDialNumber((prev) => prev.slice(0, -1));
                    } else if (!e.ctrlKey && !e.metaKey && !e.altKey) {
                      const allowed = /^[0-9*#+]$/;
                      if (allowed.test(e.key)) {
                        e.preventDefault();
                        setDialNumber((prev) =>
                          prev.length < 10 ? prev + e.key : prev
                        );
                      }
                    }
                  }}
                  placeholder="Enter Number"
                  style={{
                    flex: 1,
                    padding: "6px 16px",
                    height: "40px",
                    border: "none",
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#1e293b",
                    textAlign: "left",
                    background: "#f8fafc",
                    outline: "none",
                    letterSpacing: "1.5px",
                  }}
                  maxLength={10}
                />
              </div>
            </div>

            <div style={{ 
              display: "grid", 
              gridTemplateColumns: "repeat(3, 1fr)", 
              gap: "12px",
              padding: "0 10px",
              marginBottom: "12px"
            }}>
              {[
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "*",
                "0",
                "#",
              ].map((digit, index) => (
                <button
                  key={index}
                  className="keypad-professional"
                  onClick={() => handleDigitClick(digit)}
                  style={{
                    width: "70%",
                    height: "45px",
                    borderRadius: "12px",
                    border: "none",
                    background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)",
                    fontSize: "17px",
                    fontWeight: "600",
                    color: "#1e293b",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    overflow: "hidden",
                    margin: "0 auto",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.15), 0 4px 6px rgba(0, 0, 0, 0.1)";
                    e.currentTarget.style.background = "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)";
                    e.currentTarget.style.background = "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)";
                  }}
                  onMouseDown={(e) => {
                    e.currentTarget.style.transform = "translateY(0) scale(0.95)";
                  }}
                  onMouseUp={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px) scale(1)";
                  }}
                >
                  {digit}
                </button>
              ))}
            </div>
            <div style={{ 
              display: "grid", 
              gridTemplateColumns: "repeat(3, 1fr)", 
              gap: "12px",
              padding: "0 10px",
              marginBottom: "12px"
            }}>
              <button
                onClick={togglePause}
                style={{
                  width: "70%",
                  height: "45px",
                  borderRadius: "12px",
                  border: "none",
                  background: activePause 
                    ? "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
                    : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                  boxShadow: activePause
                    ? "0 4px 12px rgba(245, 158, 11, 0.3)"
                    : "0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)",
                  fontSize: "18px",
                  color: activePause ? "white" : "#1e293b",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto",
                }}
                onMouseEnter={(e) => {
                  if (!activePause) {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.15)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!activePause) {
                    e.currentTarget.style.transform = "translateY(0)";
                  }
                }}
              >
                <i className="fa fa-pause"></i>
              </button>
              <button
                onClick={() => handleDigitClick("+")}
                style={{
                  width: "70%",
                  height: "45px",
                  borderRadius: "12px",
                  border: "none",
                  background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)",
                  fontSize: "20px",
                  fontWeight: "600",
                  color: "#1e293b",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                +
              </button>
              <button
                onClick={toggleMic}
                style={{
                  width: "70%",
                  height: "45px",
                  borderRadius: "12px",
                  border: "none",
                  background: activeMic
                    ? "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)"
                    : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                  boxShadow: activeMic
                    ? "0 4px 12px rgba(239, 68, 68, 0.3)"
                    : "0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)",
                  fontSize: "18px",
                  color: activeMic ? "white" : "#1e293b",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto",
                }}
                onMouseEnter={(e) => {
                  if (!activeMic) {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.15)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!activeMic) {
                    e.currentTarget.style.transform = "translateY(0)";
                  }
                }}
              >
                <i className="fa fa-microphone"></i>
              </button>
            </div>

            <div style={{ 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center",
              padding: "0 10px",
              marginTop: "8px",
              width: "90%",
              margin: "8px auto 0 auto"
            }}>
              <button
                onClick={handleBackspace}
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "12px",
                  border: "none",
                  background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)",
                  fontSize: "20px",
                  fontWeight: "600",
                  color: "#64748b",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.15)";
                  e.currentTarget.style.color = "#ef4444";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.color = "#64748b";
                }}
              >
                ←
              </button>
              
              {showPhone ? (
                <div
                  className="hangup call reject"
                  id="hangup"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    boxShadow: "0 6px 20px rgba(239, 68, 68, 0.4), 0 0 0 4px rgba(239, 68, 68, 0.1)",
                    transition: "all 0.3s ease",
                    border: "none",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.1)";
                    e.currentTarget.style.boxShadow = "0 8px 24px rgba(239, 68, 68, 0.5), 0 0 0 6px rgba(239, 68, 68, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "0 6px 20px rgba(239, 68, 68, 0.4), 0 0 0 4px rgba(239, 68, 68, 0.1)";
                  }}
                >
                  <i className="fa fa-phone" style={{ fontSize: "18px", color: "white", transform: "rotate(135deg)" }}></i>
                </div>
              ) : (
                <div 
                  className="call answer" 
                  id="call"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    boxShadow: "0 6px 20px rgba(16, 185, 129, 0.4), 0 0 0 4px rgba(16, 185, 129, 0.1)",
                    transition: "all 0.3s ease",
                    border: "none",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.1)";
                    e.currentTarget.style.boxShadow = "0 8px 24px rgba(16, 185, 129, 0.5), 0 0 0 6px rgba(16, 185, 129, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "0 6px 20px rgba(16, 185, 129, 0.4), 0 0 0 4px rgba(16, 185, 129, 0.1)";
                  }}
                >
                  <i className="fa fa-phone" style={{ fontSize: "18px", color: "white" }}></i>
                </div>
              )}
              
              <div style={{ width: "45px" }}></div>
            </div>
          </div>
        </div>

        {/* <div className="chat-close" onClick={handleCloseChat}>
          &times;
        </div>
        {isMinimized ? (
          <div className="chat-toggle" onClick={handleMaximizeChat}>
            <span className="chat-button">+</span>
          </div>
        ) : (
          <div className="chat-toggle" onClick={handleMinimizeChat}>
            <span className="chat-button">−</span>
          </div>
        )} */}
      </div>
      <audio src={SampleAudio} className="hide" id="remoteAudio" controls="">
        <p>Your browser doesn't support HTML5 audio.</p>
      </audio>
    </>
  );
}

export default ChatWidget;
